import { array, object } from 'yup';
import { useGetSignatorySchema } from 'app/domains/esigning/components/ESignSignatoryFormDialog';
export const useSchema = () => {
    const defaultSignatorySchema = useGetSignatorySchema();
    const schema = object().shape({
        signatories: array().required().of(defaultSignatorySchema),
    });
    return schema;
};
